import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = 14, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={size} strokeWidth={1.5}
        className={i <= Math.round(value) ? "fill-gold text-gold" : "text-taupe/40"} />
    ))}
  </span>
);
